// @codekit-prepend quiet 'klaro.config.js';
// @codekit-prepend quiet 'klaro-no-css.js';
// @codekit-prepend quiet 'jquery-3.3.1.min.js';
// @codekit-prepend quiet '_bootstrap/bootstrap.js';
// @codekit-prepend quiet 'jquery.midnight.min.js';
// @codekit-prepend quiet 'jquery.tilt.js';
// @codekit-prepend quiet 'jquery.owl.carousel.min.js';
// @codekit-prepend quiet 'smooth-scroll.polyfills.min.js';
// @codekit-prepend quiet 'jquery.photoswipe.js';
// @codekit-prepend quiet 'jquery.justifiedGallery.min.js';



$(document).ready(function(){

    /* Smooth-Scroll */
    var scroll = new SmoothScroll('[data-scroll]', {
        speed: 1000
    });

    /* MIDNIGHT */
    $('.lima-navbar').midnight();

    /* VIDEO BACKGROUND */
    // $(".superhero").vb({
    //     volume:0,
    //     autoPlay:true,
    //     mediaEndAction:"loop",
    //     preload:'auto',
    //     aspectRatio:2,
    //     forceMobileAutoplay:true,
    //     useKeyboardNavigationForPlayback:false,
    //     media:[
    //         {
    //             type:'video',
    //             path:'assets/images/lima-video-bg-2018_v2.mp4',
    //             poster:'assets/images/lima-video-bg-2018.jpg',
    //         }
    //     ]
    //
    // });

    /* TABS */
    $('.nav-tabs a').on('click', function (e) {
        e.preventDefault()
        $(this).tab('show')
    })

    /* TILT-EFFECT */
    $('.js-tilt').tilt({
        perspective: 1000,
        maxTilt: 10,
        scale: 1.04,
        glare: true,
        maxGlare: .5
    });

    /* SLIDER */
    $(".owl-superhero").owlCarousel({
        navigation : false,
        dots: false,
        animateOut: 'fadeOut',
        smartSpeed: 1000,
        autoplay: true,
        autoplayTimeout: 3000,
        loop: true,
        lazyLoad: true,
        items : 1,
        itemsDesktop : false,
        itemsDesktopSmall : false,
        itemsTablet: false,
        itemsMobile : false
    });

    $(".owl-partner").owlCarousel({
        dots:true,
        margin:80,
        loop:true,
        autoplay:true,
        autoplayTimeout:3500,
        autoplaySpeed:500,
        responsive:{
            0:{
                items:2,
            },
            576:{
                items:3
            },
            992:{
                items:4
            },
            1200:{
                items:5
            }
        }
    });

    /* ARTICLE GALLERY */

    var slideSelector = 'a',
        options     = {
            bgOpacity: 0.95
        },
        events      = {
            close: function () {
                console.log('closed');
            }
        };


    $('.gallery').photoSwipe(slideSelector, options, events);

    $(".gallery").justifiedGallery({
        selector:'figure, div:not(.spinner)',
        rowHeight:200,
        lastRow: 'nojustify',
        captions: false,
        margins:8,
        border:0,
    });

    /* ARTICLE AOS */

    $.when( setAttributes() ).done(function() {

        AOS.init({
            offset: 0,
            duration: 800,
            once: true,
            easing: 'ease-out-cubic', //'ease-out',
        });


    });

});

function setAttributes() {

    /* AOS */
    $('.article-content figure, .article-content h2, .article-content p, .article-content blockquote, .article-content hr, .article-content ul').attr('data-aos','fade-up');
    $('.article-content h2, .article-content h3, .article-content h4, .article-content h5, .article-content h6').attr('data-aos','fade-up');
    // $('.article-content p').attr('data-aos','fade-up');
    // $('.article-content blockquote').attr('data-aos','fade-up');
    // $('.article-content hr').attr('data-aos','fade-up');

    return true;
}





